import './styles.scss'
import React from 'react'
import { I18n } from 'react-redux-i18n'

const FreeTrialBanner = ({ customContainerStyles, freeTrialDays }) => {
  if (freeTrialDays <= 0) return null

  return (
    <div
      className={`
        free-trial-banner
        ${customContainerStyles ? customContainerStyles : ''}
      `}
    >
      <strong>{I18n.t('dashboard_free-trial')}</strong>
      <p>
        {I18n.t('free_trial_days_left')} {freeTrialDays} <span>{I18n.t(freeTrialDays === 1 ? 'dashboard_day' : 'dashboard_days')}</span>
      </p>
    </div>
  )
}

export default FreeTrialBanner
